import React from 'react';
import T from 'prop-types';
import { LoginForm } from './LoginForm';

const overlay = { backgroundColor: '#00000087' };
const centerBox = {
    maxWidth: '800px',
    top: '45%',
    transform: 'translate(0%,-45%)',
    overflow: 'hidden',
    height: 'max-content',
};

const SessionExpired = (props) => (
    <div
        className="text-left text-xs fixed top-0 left-0 w-full h-screen flex item-center justify-center z-40"
        style={overlay}
    >
        <div
            className="relative bg-white w-4/5 md:w-3/5 lg:w-2/5 mx-auto rounded min-h-0"
            style={centerBox}
        >
            <div className="text-blue-700 font-semibold py-2 md:py-4 text-lg px-4 bg-blue-100  border border-gray-200">
                Session Expired
            </div>
            <LoginForm
                authenticateLink={props.authenticateLink}
                emailBasedAuthentication={props.emailBasedAuthentication}
            />
        </div>
    </div>
);

SessionExpired.propTypes = {
    reLogin: T.func,
    authenticateLink: T.func,
    emailBasedAuthentication: T.bool,
};

export default SessionExpired;
